export{Cell,Table,TableBody,TableHead,TableHeader,TableRow}from"@vds-core/tables";
